// extracted by mini-css-extract-plugin
export default {"manageTeamFormDialog":"ManageTeamForm_manageTeamFormDialog__cUgyl","buttonGroup":"ManageTeamForm_buttonGroup__Tddeh"};